//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { InsurStore,InsurMutations } from './store'
import Inform from '@/components/layer/inform.vue';
import BaseInfo  from './components/baseInfo'
import Monthly  from './components/monthly'
import Mechanism  from './components/mechanism'
import Details  from './components/details'
import UseInfo  from './components/useInfo'
import Basefoot  from './components/Basefoot'
import { Share } from '@/utils/commonUtils'

import { insurance } from '@/model/api/detailService'
import clearKeepAlive from '@/utils/mixin/mixinCache'
import Txrweb from '@/utils/mixin/mixinTxrweb'

export default {
    name: "stencilInsurance",
    mixins:[clearKeepAlive,Txrweb],

    data(){
        return {
            src:'https://static.soyoung.com/sy-pre/sy-headImg-1588126201715.png',
            load:false
        }
    },
    components:{
        Inform,
        BaseInfo,
        Monthly,
        Mechanism,
        Details,
        UseInfo,
        Basefoot
    },
    computed: {
        templateFlag(){
            return this.$route.query.templateFlag
        },
        modify(){
            return this.$route.query.modify
        },
        cache(){
            document.title = InsurStore.insurance.cache.title
            return InsurStore.insurance.cache
        }
    },
    activated(){
        InsurMutations.setPay_period('year') // 年缴 
    },
    watch: {
        load(newVal, oldVal) {
            if(newVal){
                const cache = this.cache
                if(cache.share && cache.share.share_content){
                    let obj = {
                        shareContent: cache.share.share_content,
                        shareTimelineContent:cache.share.share_title,
                        shareImgurl:cache.share.share_imgurl,
                        shareTitle:cache.share.share_title,
                        shareUrl: `${window.location.href}`,
                        rightBtnStatus: 1
                    };
                    let objCircle =  {
                        shareContent: cache.share_circle.share_content,
                        shareTimelineContent:cache.share_circle.share_content,
                        shareImgurl:cache.share_circle.share_imgurl,
                        shareTitle:cache.share_circle.share_content,
                        shareUrl: `${window.location.href}`,
                        rightBtnStatus: 1
                    }
                    Share(obj,'sybao_ins_product_share_result_sys',objCircle)
                }
                
            }

        },
    },
    created() {
        this.getInfo()
    },
    mounted () {
        this.STATISTICS_CONFIG.insur_proinfo_page();
    },
    methods:{
        getInfo(){
            let plan = `${this.templateFlag}?modify=${this.modify}`
            insurance(plan).then(data=>{
                InsurMutations.insurance(data);
            }).catch(()=>{
            }).finally(()=>{
                this.load = true
            })
   
        },
        btnClick(){
            this.STATISTICS_CONFIG.insur_proinfo_submit2_click()
            this.$nextTick(()=>{
                this.$router.push({
                    path: "/insuranceInfo",
                    query:this.$route.query
                });
            })
        },
        custUrlClick(){
            this.STATISTICS_CONFIG.insur_proinfo_contactonline_click()
        }
    }
}
